// Where the +N / -N pill of a changed counter is drawn (the live motion layer and the replay overlay share it).

export const FLOAT_W = 44, FLOAT_H = 20;

/**
 * Where a counter's +N / -N pill (FLOAT_W x FLOAT_H) is drawn: never over the counter's own digits and never over a header. A counter in a
 * seat strip sends its pill to the free right end of the strip's header row (side by side when several counters change at once, each carrying
 * its icon); any other counter gets it directly above its box (below it when there is no room above).
 */
export function deltaPlace(el: Element, r: { left: number; right: number; top: number; bottom: number; width: number }, lanes: Map<Element, number>, viewportWidth: number): { left: number; top: number; rise: number; inHead: boolean } {
  const head = el.closest('[data-motion-seat]')?.querySelector('.strip-head') ?? null;
  const h = head?.getBoundingClientRect();
  if (head && h && h.width > 0 && h.height > 0) {
    const lane = lanes.get(head) ?? 0;
    lanes.set(head, lane + 1);
    // the right end of the header row is free (the name sits at the left; the turn clock, when shown, takes about 30 px)
    const left = h.right - 30 - lane * (FLOAT_W + 4) - FLOAT_W;
    if (left > h.left + 56) return { left, top: h.top + (h.height - FLOAT_H) / 2, rise: 4, inHead: true };
  }
  const above = r.top - FLOAT_H - 2;
  return { left: Math.min(Math.max(2, r.left + r.width / 2 - FLOAT_W / 2), viewportWidth - FLOAT_W - 2), top: above >= 0 ? above : r.bottom + 2, rise: above >= 0 ? 8 : -8, inHead: false };
}
